export const config = {
  routeBaseName: '/ottobot',
  availablePrefixes: ['ottobot']
};
